import React from "react"
import PropTypes from 'prop-types';
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"
import MetaTitle from "~/components/Shared/MetaTitle";
import { route, routes } from "~/helpers/routeHelper";
import errorImg from "~/assets/images/error-img.png"

const ServerError = props => {
  return <React.Fragment>
    <div className="account-pages my-5 pt-5">
      <MetaTitle>Server error</MetaTitle>
      <Container>
        <Row>
          <Col lg="12">
            <div className="text-center mb-5">
              <h1 className="display-2 font-weight-medium">Oops</h1>
              <h4 className="text-uppercase">{props.title || 'An error has occurred'}</h4>
              <div className="mt-5 text-center">
                <Link className="btn btn-primary" to={props.btnLink || route(routes.home)}>{props.btnText || 'Back to dashboard'}</Link>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="8" xl="6">
            <div>
              <img src={errorImg} alt="" className="img-fluid" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  </React.Fragment>
}

ServerError.propTypes = {
  title: PropTypes.string,
  btnLink: PropTypes.string,
  btnText: PropTypes.string,
}

export default ServerError
